import { get } from "@/api/client";

export interface TeamMember {
  user_id: string;
  full_name: string;
  email: string;
  role: string;
  job_title: string | null;
  department: string | null;
  start_date: string | null;
  percent: number;
  completed: number;
  total: number;
  required_total: number;
  required_done: number;
  outstanding: number;
}

export interface TeamTotals {
  people: number;
  avg_percent: number;
  fully_done: number;
}

export interface TeamReport {
  members: TeamMember[];
  totals: TeamTotals;
}

export interface AuditEntry {
  id: string;
  action: string;
  actor_user_id: string | null;
  actor_name: string | null;
  entity: string | null;
  entity_id: string | null;
  details: Record<string, unknown> | null;
  ip: string | null;
  created_at: string;
}

async function unwrap<T>(p: Promise<{ ok: true; data: T } | { ok: false; err: { message: string } }>): Promise<T> {
  const r = await p;
  if (!r.ok) throw new Error(r.err.message);
  return r.data;
}

export const fetchTeamReport = (signal?: AbortSignal) => unwrap<TeamReport>(get("/api/reports/team", signal));
export async function fetchAuditLog(limit = 100, signal?: AbortSignal): Promise<AuditEntry[]> {
  const d = await unwrap<{ entries: AuditEntry[] }>(get(`/api/reports/audit?limit=${limit}`, signal));
  return d.entries;
}
